import styled from 'styled-components'

export const NoteTooltipContent = styled.div`
  max-width: 214px;
`
